module.exports = __webpack_public_path__ + "img/Bridge Icon.e8c98668.svg";